import { BarChart2, DollarSign, Menu, Settings, ShoppingBag,Lock, TrendingUp, Users, Mail, UserRoundCog, ContactRound, MessageCircle, MessagesSquare } from "lucide-react";
import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ChartColumnStacked } from "lucide-react";

const SIDEBAR_ITEMS = [
    { name: "المسؤولون", icon: Users, color: "#EC4899", href: "/admins" },
    { name: "المدفوعات", icon: DollarSign, color: "#10B981", href: "/sales" },
    { name: "الرسائل", icon: Mail, color: "#F59E0B", href: "/manage-messages" },
    { name: "ادارة المدربين", icon: TrendingUp, color: "#6366f1", href: "/analytics" },
    { name: "قبول المدربين", icon: Lock, color: "#3B82F6", href: "/manage-trainers" },
    { name: "ادارة الفئات", icon: ChartColumnStacked, color: "#6EE7B7", href: "/manage-categories" },
    { name: "ادارة ألمتدربين", icon: UserRoundCog, color: "#13E2B4", href: "/manage-users" },
    { name: "رسائل المستخدمين", icon: ContactRound, color: "#6AE7E7", href: "/manage-contacts" },
    { name: "مراسلة المستخدمين", icon: MessageCircle, color: "#6AE7E7", href: "/message-user" },
    { name: "الدخول الي المحادثة", icon: MessagesSquare , color: "#6AE7E7", href: "/enter-chat" },

];

const Sidebar = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    return (
        <motion.div
            className={`relative z-50 transition-all duration-300 ease-in-out flex-shrink-0 h-full ${isSidebarOpen ? "w-64" : "w-20"}`}
            animate={{ width: isSidebarOpen ? 256 : 80 }}
        >
            <div className="h-full bg-gray-200 bg-opacity-50 backdrop-blur-md p-4 flex flex-col border-l border-gray-500">
                <motion.button
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.9 }}
                    onClick={() => setIsSidebarOpen(!isSidebarOpen)}
                    className="p-2 text-primary-200 rounded-full hover:bg-gray-200 transition-colors max-w-fit self-end"
                >
                    <Menu size={24} />
                </motion.button>

                <nav className="mt-8 flex-grow">
                    {SIDEBAR_ITEMS.map((item) => (
                        <Link key={item.href} to={item.href}>
                            <motion.div 
                                className="flex flex-row-reverse items-center p-4 text-sm font-medium rounded-lg hover:bg-gray-300 transition-colors mb-2 gap-3"
                            >
                                <item.icon size={20} style={{ color: item.color, minWidth: "20px" }} />
                                <AnimatePresence>
                                    {isSidebarOpen && (
                                        <motion.span
                                            className="whitespace-nowrap text-black"
                                            initial={{ opacity: 0, width: 0 }}
                                            animate={{ opacity: 1, width: "auto" }}
                                            exit={{ opacity: 0, width: 0 }}
                                            transition={{ duration: 0.2, delay: 0.3 }}
                                        >
                                            {item.name}
                                        </motion.span>
                                    )}
                                </AnimatePresence>
                            </motion.div>
                        </Link>
                    ))}
                </nav>
            </div>
        </motion.div>
    );
};

const AdminSidebar = () => {
    return (
        <div className="flex h-screen bg-white text-gray-100 overflow-hidden justify-end">
            <Sidebar />
        </div>
    );
};

export default AdminSidebar;
